// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
import type { AppData, Summary, Parliamentarian, MpDetail } from './types';

async function getJson<T>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Failed to load ${url} (${res.status})`);
  return (await res.json()) as T;
}

export async function loadData(): Promise<AppData> {
  const [summary, people] = await Promise.all([
    getJson<Summary>('data/summary.json'),
    getJson<Parliamentarian[]>('data/parliamentarians.json'),
  ]);
  const bySlug = new Map(people.map((p) => [p.slug, p]));
  return { summary, people, bySlug };
}

const detailCache = new Map<string, MpDetail>();

export async function loadMpDetail(slug: string): Promise<MpDetail> {
  const cached = detailCache.get(slug);
  if (cached) return cached;
  const detail = await getJson<MpDetail>(`data/mp/${encodeURIComponent(slug)}.json`);
  detailCache.set(slug, detail);
  return detail;
}
